(ns frontend.ui.component.form.style
  (:require
   [frontend.ui.style.theme.core :refer
    [border-radius border-width color edge-size text-size]]
   [garden.util :refer [space-join]]
   [frontend.ui.style.theme.core :as theme]))

(defn form-group
  []
  {:padding-bottom "16px"})

(defn label
  []
  {:display        "block"
   :font-weight    "bold"
   :padding-bottom "8px"})

(defn input
  []
  (with-meta
    {:width         "100%"
     :padding       (space-join [(edge-size :xsmall)
                                 (edge-size :small)])
     :font-size     (text-size :small :size)
     :font-family   "inherit"
     :border-radius (border-radius :xxxsmall)
     :border        (space-join ["1px"
                                 "solid"
                                 (theme/color [:text-input :border :regular])])}
    {:pseudo
     {:hover
      {:outline "none"
       :border  (space-join [(border-width :medium)
                             "solid"
                             (theme/color [:text-input :border :hover])])}
      :focus
      {:outline "none"
       :border  (space-join [(border-width :medium)
                             "solid"
                             (theme/color [:text-input :border :focus])])}}}))

(defn suggestion-list
  []
  {:display    "block"
   :overflow-y "auto"
   :padding    "8px 0"
   :max-height "min(400px, 30vh)"})

(defn suggestion-list-item
  [matching-item?]
  (with-meta
    {:display        "block"
     :padding-bottom "8px"
     :cursor         "pointer"
     :font-weight    "normal"
     :color          (if matching-item?
                       (theme/color [:link :secondary :match])
                       (theme/color [:link :secondary :color]))}
    {:pseudo
     {:hover {:color (theme/color [:link :primary :color])
             }}}))
